import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Default location service for UI Router
 */
export class LocationService {
  constructor(location) {
    this.location = location;
    _defineProperty(this, "listeners", []);
    /**
     * notify ui-router about external location update
     */
    _defineProperty(this, "notifyListeners", () => {
      this.listeners.forEach(listener => listener(new Event('locationChange')));
    });
  }
  /**
   * Returns full internal url with search and hash
   * if newUrl is provided, it will call `set` method
   */
  url(newUrl, replace, state) {
    const hash = this.hash();
    const pathname = this.path();
    const params = new URLSearchParams(this.search());
    const search = params.toString();
    const url = [pathname, search ? `?${search}` : '', hash ? `#${hash}` : ''].join('');
    if (!!newUrl && newUrl !== url) {
      this.set(this.omitExtra(newUrl), {
        excludeFromHistory: replace,
        disableScrollToTop: this.disableScrollToTop(newUrl)
      });
    }
    return url;
  }
  omitExtra(path) {
    const url = new URL(path, 'http://foo.bar');
    url.searchParams.delete('disableScrollToTop');
    return url.href.replace(url.origin, '');
  }
  disableScrollToTop(path) {
    const url = new URL(path, 'http://foo.bar');
    if (!url.searchParams.has('disableScrollToTop')) {
      return false;
    }
    return url.searchParams.get('disableScrollToTop') === '1';
  }

  /**
   * Persist client's url i.e. via window.location.pushState
   */
  set(url, options) {}
  hash() {
    const url = new URL(this.location.url);
    return url.hash.replace(/^#/, '');
  }

  /**
   * Get current "internal" path
   * should not include baseUrl
   */
  path() {
    const {
      path
    } = this.location;
    const pathname = path.filter(entry => !!entry).join('/'); // remove double slashes

    return `/${pathname}`;
  }
  search() {
    return this.location.query;
  }
  dispose() {
    this.listeners.forEach(listener => listener(null));
    this.listeners = [];
  }

  /**
   * @ui-router/core is subscribed to updates via this method
   */
  onChange(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }
}
//# sourceMappingURL=LocationService.js.map